// extracted by mini-css-extract-plugin
export var createdDate = "_jv-1";
export var divider = "_jv-2";
export var headerDivider = "_jv-3";
export var messagesCard = "_jv-0";
export var messagesContainer = "_jv-6";
export var messagesContainerWrapper = "_jv-4";
export var showLeftPanelButton = "_jv-8";
export var topButtons = "_jv-7";
export var withPadding = "_jv-5";